import React, { useCallback, useEffect, useState } from 'react';

import SelectTree from 'components/SelectTree';

interface IProps {
  onChange?: any;
  options?: any;
  loading?: boolean;
  placeholder?: string;
  itemLabel?: string;
  itemValue?: string;
  clearInput?: boolean;
}

const SelectTreeFilter: React.FC<IProps> = ({
  onChange,
  options,
  loading,
  placeholder,
  itemLabel,
  itemValue,
  clearInput
}) => {
  const [data, setData] = useState<any[]>([]);

  const convertServiceFormatToComponent = useCallback((opts: any) => {
    if (!opts || !Array.isArray(opts)) {
      return;
    }

    const newData: any[] = [];

    opts.forEach((item: any) => {
      const newItem: any = {
        label: `${item.id} - ${item.title}`,
        value: item.id,
        id: item.id
      };

      if (!item.parent_id) {
        newItem.children = [];
        const variations = opts.filter((prod: any) => prod.parent_id === item.id);

        if (variations) {
          variations.forEach((vari: any) => {
            newData.push({
              label: `${vari.id} - ${vari.title}`,
              value: vari.id,
              id: vari.id
            });
          });
        }

        newData.push(newItem);
      } else {
        const existFather = opts.find((prod: any) => prod.id === item.parent_id);

        if (!existFather) {
          newData.push(newItem);
        }
      }
    });

    setData(newData);
  }, []);

  useEffect(() => {
    convertServiceFormatToComponent(options);
  }, [options, convertServiceFormatToComponent]);

  useEffect(() => {
    if (clearInput && data.length > 0) {
      const newData = [...data];
      newData[0].checked = false;
      setData(newData);
    }
  }, [clearInput]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = useCallback(
    (selecteds: any) => {
      if (!onChange) {
        return;
      }

      const products: any[] = [];

      selecteds.forEach((item: any) => {
        const prod = options.find((currProd: any) => currProd.id === item.id);

        if (itemLabel) {
          prod.label = prod[itemLabel];
        }

        if (itemValue) {
          prod.value = prod[itemValue];
        }

        products.push(prod);

        if (Array.isArray(item._children) && item._children.length) {
          item._children.forEach((childId: any) => {
            const child = options.find((currProd: any) => currProd.id === childId);
            const newChild: any = {};
            newChild.label = child[itemLabel];
            newChild.value = child[itemValue];
            products.push(newChild);
          });
        }
      });

      onChange(products);
    },
    [onChange, options, itemLabel, itemValue]
  );

  return (
    <SelectTree
      loading={loading}
      onChange={handleChange}
      placeholder={placeholder || 'Selecione os produtos'}
      data={data}
      clear={clearInput}
    />
  );
};

export default SelectTreeFilter;
